import styles from './Field.module.scss';
import { ReactElement } from 'react';

interface FieldProps {
  uid: string;
  label: ReactElement | string;
  children: ReactElement;
}

export function Field({ uid, label, children }: FieldProps) {
  return (
    <div className={styles.field}>
      <label htmlFor={uid} className={styles.field__label}>
        {label}
      </label>
      {children}
    </div>
  );
}

export default Field;
